"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteWithConfirmController = exports.useDeleteWithUndoController = void 0;
var useDeleteWithUndoController_1 = __importDefault(require("./useDeleteWithUndoController"));
exports.useDeleteWithUndoController = useDeleteWithUndoController_1.default;
var useDeleteWithConfirmController_1 = __importDefault(require("./useDeleteWithConfirmController"));
exports.useDeleteWithConfirmController = useDeleteWithConfirmController_1.default;
